// extracted by mini-css-extract-plugin
export default {"editPopupContainer":"EditPage_editPopupContainer__sAQbM","popIn":"EditPage_popIn__wR7sL"};